export const services = [
  {
    id: 1,
    name: "Hair Fall Oil",
    description: "Natural Ayurvedic oil for hair strengthening and growth",
  },
  {
    id: 2,
    name: "Amla Juice",
    description: "Rich in Vitamin C for immunity and digestion",
  },
  {
    id: 3,
    name: "Ginger Juice",
    description: "Natural remedy for digestive health",
  },
  {
    id: 4,
    name: "Garlic (Lahsun) Juice",
    description: "Supports cardiovascular health",
  },
  {
    id: 5,
    name: "Jamun Juice",
    description: "Beneficial for diabetes management",
  },
  {
    id: 6,
    name: "Renal Calculi Medicines",
    description: "Ayurvedic treatment for kidney stones",
  },
];
